import { render } from "./JourneyOrient.vue?vue&type=template&id=7b78c6ef"
import script from "./JourneyOrient.vue?vue&type=script&lang=js"
export * from "./JourneyOrient.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__